import { BOARD_CONFIG, IS_MIX_CATALOG } from "@/config/browserBoard";
import { R18BlurOnboardingModal } from "@/features/r18-blur-onboarding/components/R18BlurOnboardingModal";
import { useR18GatePresenter } from "@/features/r18-blur-onboarding/useOnboardingPresenter";
import { ComponentScope } from "@/shared/ui/component-hierarchy/ComponentScope";

export const R18BlurOnboardingGate: React.FunctionComponent = () => {
  if (!IS_MIX_CATALOG && BOARD_CONFIG.allowR18ThreadCreation === false)
    return null;
  return <R18BlurOnboardingPrompt />;
};

const R18BlurOnboardingPrompt: React.FunctionComponent = () => {
  const presentation = useR18GatePresenter();
  if (!presentation.shouldMount) return null;
  return (
    <ComponentScope node={presentation.node}>
      <R18BlurOnboardingModal
        isOpen={presentation.isOpen}
        onDismiss={(): void => {
          presentation.node.dispatch({ type: "r18-onboarding.dismiss" });
        }}
        onComplete={(): void => {
          presentation.node.dispatch({ type: "r18-onboarding.complete" });
        }}
      />
    </ComponentScope>
  );
};
